import { getOddsValue, parseExprCombStr } from "./common";
import { exprWPQCompare } from './parseWPQTop'

export const parseWPQBanker = (meeting, pmPool, message) => {
    if(message != null){
        if(message.updAt != null && message.cmb !=null){
            pmPool.lastUpdateTime = message.updAt;
            let banker10 = message.cmb.filter(x=>x.odds != null).sort(bankerCompare);
            let tmpOddsNodes = [];
            if(banker10.length<=0){  // ReservedOrRefunded status
                banker10 = message.cmb.filter(x=>x.scrOrd != null).sort(orderCompare);
            }
            let curRace = meeting.races.find(item => item.no == pmPool.leg.races[0])
            let curRunners = curRace.runners.filter(r => r.no)
            // for(let i =1 ;i<pmPool.oddsNodes.length+1;i++){
            //     let newOddsNodes = {
            //         bankerOdds: [],
            //         combString: i
            //     };
            //     tmpOddsNodes.push(newOddsNodes)
            // }
            curRunners.forEach(runner =>{
                let newOddsNodes = {
                    bankerOdds: [],
                    combString: runner.no
                };
                tmpOddsNodes.push(newOddsNodes)
            })
            banker10.forEach(comb => {
                let currentNodeVal = tmpOddsNodes.findIndex(x=> x.combString==parseInt(comb.cmbStr.slice(0,2)));
                if(currentNodeVal>=0){
                    tmpOddsNodes[currentNodeVal].bankerOdds.push(comb);
                }
                currentNodeVal = tmpOddsNodes.findIndex(x=> x.combString==parseInt(comb.cmbStr.slice(3,5)));
                if(currentNodeVal>=0){
                    tmpOddsNodes[currentNodeVal].bankerOdds.push(comb);
                }
            });
            pmPool.oddsNodes = tmpOddsNodes.map(oddNode =>{
                let topTenBankerOddds = oddNode.bankerOdds.sort(oddsCompare).slice(0,10).sort(bankerCompare);
                const newBankerOdds = topTenBankerOddds.map((item) => ({
                    combString: item.cmbStr,
                    oddsValue: getOddsValue(item.odds, item.cmbSt),
                }))
                return {
                    bankerOdds: newBankerOdds,
                    combString: oddNode.combString,
                    hotFavourite: null,
                    oddsDropValue: null,
                    oddsValue: null,
                }

            })
            // pmPool.oddsNodes.forEach(oddNode =>{
            //     let currentNodeVal = tmpOddsNodes.findIndex(x=> x.combString== oddNode.combString);
            //     if(currentNodeVal>=0){
            //         let topTenBankerOddds = tmpOddsNodes[currentNodeVal].bankerOdds.sort(oddsCompare).slice(0,10).sort(bankerCompare);
            //         const newBankerOdds = topTenBankerOddds.map((item) => ({
            //             combString: item.cmbStr,
            //             oddsValue: item.odds,
            //           }));
            //         oddNode.bankerOdds = newBankerOdds;
            //     }
            // });
        }
    }
}
export const parseExprWPQBanker = (meeting, pmPool, message) => {
    if(message != null){
        if(message.updAt != null && message.cbs !=null){
            pmPool.lastUpdateTime = message.updAt;
            let banker10 = message.cbs.filter(x=>x.ods != null && Number(x.ods) > 0).sort(exprBankerCompare);
            let tmpOddsNodes = [];
            if(banker10.length<=0){  // ReservedOrRefunded status
                banker10 = message.cbs.filter(x=>x.wP != null).sort(exprWPQCompare);
            }
            let curRace = meeting.races.find(item => item.no == pmPool.leg.races[0])
            let curRunners = curRace.runners.filter(r => r.no)
            // for(let i =1 ;i<pmPool.oddsNodes.length+1;i++){
            //     let newOddsNodes = {
            //         bankerOdds: [],
            //         combString: i
            //     };
            //     tmpOddsNodes.push(newOddsNodes)
            // }
            curRunners.forEach(runner =>{
                let newOddsNodes = {
                    bankerOdds: [],
                    combString: runner.no
                };
                tmpOddsNodes.push(newOddsNodes)
            })
            banker10.forEach(comb => {
                let combStrArray = comb.cb?.split('+') || []
                let currentNodeVal = tmpOddsNodes.findIndex(x=> x.combString==parseInt(combStrArray?.[0]));
                if(currentNodeVal>=0){
                    tmpOddsNodes[currentNodeVal].bankerOdds.push(comb);
                }
                currentNodeVal = tmpOddsNodes.findIndex(x=> x.combString==parseInt(combStrArray[1]));
                if(currentNodeVal>=0){
                    tmpOddsNodes[currentNodeVal].bankerOdds.push(comb);
                }
            });
            // if(pmPool.oddsNodes.length > 0){
            //     pmPool.oddsNodes.forEach(oddNode =>{
            //         let currentNodeVal = tmpOddsNodes.findIndex(x=> x.combString== oddNode.combString);
            //         if(currentNodeVal>=0){
            //             let topTenBankerOddds = tmpOddsNodes[currentNodeVal].bankerOdds.sort(exprOddsCompare).slice(0,10).sort(exprBankerCompare);
            //             console.log(topTenBankerOddds)
            //             const newBankerOdds = topTenBankerOddds.map((item) => ({
            //                 combString: parseExprCombStr(item.cb),
            //                 oddsValue: item.ods,
            //               }));
            //             oddNode.bankerOdds = newBankerOdds;
            //         }
            //     });
            // }else{
            // }
            pmPool.oddsNodes = tmpOddsNodes.map(oddNode =>{
                let topTenBankerOddds = oddNode.bankerOdds.sort(exprOddsCompare).slice(0,10).sort(exprBankerCompare);
                const newBankerOdds = topTenBankerOddds.map((item) => ({
                    combString: parseExprCombStr(item.cb),
                    oddsValue: getOddsValue(item.ods, item.st),
                  }))
                return {
                    bankerOdds: newBankerOdds,
                    combString: oddNode.combString,
                    hotFavourite: null,
                    oddsDropValue: null,
                    oddsValue: null,
                }

            })
        }
    }
}
function bankerCompare ( a, b ){
    if( a.cmbStr< b.cmbStr ){
        return -1;
    }
    if( a.cmbStr > b.cmbStr ){
        return 1;
    }
    if ( parseFloat(a.odds) < parseFloat(b.odds)){
        return -1;
    }
    if ( parseFloat(a.odds) > parseFloat(b.odds)){
        return 1;
    }
    return 0;
}

function exprBankerCompare ( a, b ){
    if( parseExprCombStr(a.cb)< parseExprCombStr(b.cb) ){
        return -1;
    }
    if( parseExprCombStr(a.cb) > parseExprCombStr(b.cb) ){
        return 1;
    }
    if ( parseFloat(a.ods) < parseFloat(b.ods)){
        return -1;
    }
    if ( parseFloat(a.ods) > parseFloat(b.ods)){
        return 1;
    }
    return 0;
}

function oddsCompare (a,b){
    if ( parseFloat(a.odds) < parseFloat(b.odds)){
        return -1;
    }
    if ( parseFloat(a.odds) > parseFloat(b.odds)){
        return 1;
    }
    return 0;
}
function exprOddsCompare (a,b){
    if ( parseFloat(a.ods) < parseFloat(b.ods)){
        return -1;
    }
    if ( parseFloat(a.ods) > parseFloat(b.ods)){
        return 1;
    }
    return 0;
}
function orderCompare ( a, b ){
    if( parseFloat(a.scrOrd)< parseFloat(b.scrOrd) ){
        return -1;
    }
    if( parseFloat(a.scrOrd) > parseFloat(b.scrOrd) ){
        return 1;
    }
    return 0;
}